export enum FeatureFlagsEnum {
    FF_Notifications = 'FF_Notifications',
    FF_DevAuditLogs = 'FF_DevAuditLogs',
    FF_DangerousMaintenanceOperations = 'FF_DangerousMaintenanceOperations',
    FF_FlowOfFunds_3_20 = 'FF_FlowOfFunds_3_20',
}
